<template>
	<div class="accordion">
		<AccordionElement :item="item" v-for="(item, iKey) in data" :key="iKey"></AccordionElement>
	</div>
</template>

<script>

import AccordionElement from "@/Components/Product/ProductDetailsContentTypes/AccordionElement.vue";

export default {
	name: "Accordion",
	props : ['data'],
	components: {
		AccordionElement
	}
}
</script>

<style scoped>

</style>